import React, { useState } from 'react';
import styles from './Dropdown.module.css';

function DropdownPersonalizado({ options, placeholder, onChange, hasError }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState('');

    const handleSelect = (option) => {
        setSelected(option);
        onChange(option);
        setIsOpen(false);
    };

    return (
        <div className={styles.dropdown}>
            <div
                className={`${styles.dropdownToggle} ${hasError ? styles.error : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {selected || placeholder}
            </div>
            {isOpen && (
                <ul className={styles.dropdownMenu}>
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className={styles.dropdownItem}
                            onClick={() => handleSelect(option)}
                        >
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default DropdownPersonalizado;
